import { createContext, useEffect, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { getPathName } from "../../../common/utils/utilsFunc";
import { AccessTokenContext } from "../../../common/context/AccessTokenProvider";

export const CgeContext = createContext();
export const ACTIONS = {
  SET_PAGOS: "SET_PAGOS",
  SET_IDCLIENT: "SET_IDCLIENT",
  SET_ALLDATAREQUEST: "SET_ALLDATAREQUEST",
  SET_ALLDATAREQUEST_RESPONSE: "SET_ALLDATAREQUEST_RESPONSE",
  SET_ERROR: "SET_ERROR",
  SET_IDLIST: "SET_IDLIST",
  SET_BASE64_BOLETA_BY_ID: "SET_BASE64_BOLETA_BY_ID",
  SET_LOAD_PAGE: "SET_LOAD_PAGE",
  SET_CURRENT_BALANCE: "SET_CURRENT_BALANCE",
};

const initialState = {
  allDataRequest: null,
  allDataRequestResponse: null,
  idCliente: null,
  currentBalance: null,
  dataPagos: {},
  errorFetch: null,
  idList: [],
  boletaBase64: "",
  loadPage: false,
};

const CgeReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_PAGOS: {
      return {
        ...state,
        dataPagos: action.payload,
      };
    }
    case ACTIONS.SET_ALLDATAREQUEST_RESPONSE: {
      return {
        ...state,
        allDataRequestResponse: action.payload,
      };
    }
    case ACTIONS.SET_ALLDATAREQUEST: {
      return {
        ...state,
        allDataRequest: action.payload,
      };
    }
    case ACTIONS.SET_IDCLIENT: {
      return {
        ...state,
        idCliente: action.payload,
      };
    }
    case ACTIONS.SET_ERROR: {
      return {
        ...state,
        errorFetch: action.payload,
      };
    }
    case ACTIONS.SET_IDLIST: {
      return {
        ...state,
        idList: action.payload,
      };
    }
    case ACTIONS.SET_BASE64_BOLETA_BY_ID: {
      return {
        ...state,
        boletaBase64: action.payload,
      };
    }
    case ACTIONS.SET_LOAD_PAGE: {
      return {
        ...state,
        loadPage: action.payload,
      };
    }
    case ACTIONS.SET_CURRENT_BALANCE: {
      return {
        ...state,
        currentBalance: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

const CgeContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);
  const [state, dispatch] = useReducer(CgeReducer, initialState);
  const { accessToken } = useContext(AccessTokenContext);

  useEffect(() => {
    if (state.idCliente !== null && getPathName() === "pagos-realizados") {
      LiferayService.getPagos(
        properties.base_url_api,
        state.idCliente,
        properties.codigo_empresa,
        properties.url_ws_empresa
      )
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_PAGOS,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error.message,
            type: ACTIONS.SET_ERROR,
          });
        });
    }
  }, [state.idCliente || state.idList || getPathName]);

  useEffect(() => {
    if (state.idCliente && getPathName() === "saldo-actual") {
      // eslint-disable-next-line no-undef
      Liferay.Service(
        "/user/get-user-by-email-address",
        {
          // eslint-disable-next-line no-undef
          companyId: Liferay.ThemeDisplay.getCompanyId(),
          // eslint-disable-next-line no-undef
          emailAddress: Liferay.ThemeDisplay.getUserEmailAddress(),
        },
        function (obj) {
          LiferayService.getCurrentBalance(
            properties.base_url_api,
            state.idCliente,
            properties.codigo_empresa,
            properties.url_ws_empresa,
            obj.screenName
          )
            .then((response) => {
              dispatch({
                payload: response,
                type: ACTIONS.SET_CURRENT_BALANCE,
              });
              dispatch({
                payload: null,
                type: ACTIONS.SET_ERROR,
              });
            })
            .catch((error) => {
              dispatch({
                payload: error.message,
                type: ACTIONS.SET_ERROR,
              });
            });
        }
      );
    }
  }, [state.idCliente]);

  useEffect(() => {
    if (state.allDataRequest && getPathName() === "saldo-actual") {
      // eslint-disable-next-line no-undef
      Liferay.Service(
        "/user/get-user-by-email-address",
        {
          // eslint-disable-next-line no-undef
          companyId: Liferay.ThemeDisplay.getCompanyId(),
          // eslint-disable-next-line no-undef
          emailAddress: Liferay.ThemeDisplay.getUserEmailAddress(),
        },
        function (obj) {
          LiferayService.getCurrentBalance(
            properties.base_url_api,
            state.allDataRequest,
            properties.codigo_empresa,
            properties.url_ws_empresa,
            obj.screenName
          )
            .then((response) => {
              dispatch({
                payload: response,
                type: ACTIONS.SET_ALLDATAREQUEST_RESPONSE,
              });
              dispatch({
                payload: null,
                type: ACTIONS.SET_ALLDATAREQUEST,
              });
              dispatch({
                payload: null,
                type: ACTIONS.SET_ERROR,
              });
            })
            .catch((error) => {
              dispatch({
                payload: error.message,
                type: ACTIONS.SET_ERROR,
              });
            });
        }
      );
    }
  }, [state.allDataRequest]);


  useEffect(() => {
    if (
      (getPathName() === "estado-del-servicio") && 
      (state.idCliente !== null || (state.idCliente !== "" && state.errorFetch))
    ) {
      LiferayService.getCurrentEstadoServicio(
        properties.base_url_api,
        state.idCliente,
        properties.codigo_empresa,
        properties.url_ws_empresa
      )
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_CURRENT_BALANCE,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error.message,
            type: ACTIONS.SET_ERROR,
          });
        });
    }
  }, [state.idCliente || state.errorFetch]);

  useEffect(() => {
    if (accessToken) {
      LiferayService.getIdList(properties.base_url_api)
        .then((response) => {
          if (response?.length === 0) {
            dispatch({
              payload: true,
              type: ACTIONS.SET_ERROR,
            });
          }
          dispatch({
            payload: response,
            type: ACTIONS.SET_IDLIST,
          });
          dispatch({
            payload: false,
            type: ACTIONS.SET_LOAD_PAGE,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        });
    }
  }, [accessToken]);

  return <CgeContext.Provider value={[state, dispatch]}>{children}</CgeContext.Provider>;
};
export default CgeContextProvider;
